<template>
    <div class="col-md-12 bg-violet text-white p-lg-6 rounded" style="font-size: 16px">

        <div class="col-md-12 row pb-4">
            <div class="col-xl-3 col-md-5 col-12  mt-2">
                <el-select clearable v-model="query.user_ids" collapse-tags filterable multiple class="w-100 custom-input" placeholder="Chọn RSM" @change="getData">
                    <el-option
                        v-for="(item, index) in users"
                        :key="index"
                        :label="item.name"
                        placeholder="Chọn RSM"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                    </el-option>
                </el-select>
            </div>
            <div class="col-xl-2 col-md-4 col-12 mt-2">
                <el-date-picker
                    style="width: 215px"
                    v-model="query.date_range"
                    type="monthrange"
                    value-format="yyyy-MM"
                    @change="changeDate"
                    range-separator="-"
                    start-placeholder="Start month"
                    end-placeholder="End month"
                >
                </el-date-picker>
            </div>
        </div>
        <div class="d-xl-flex col-12 p-lg-0 mt-3">
            <div class="col-xl-3 col-md-12  mt-2">
                <div class="table-config text-center p-4 custom-border custom-background justify-content-center overflow-auto h-100">
                    <h2>Doanh số đội nhóm</h2>
                    <h1 style="font-size: 30px">{{ totalAllAmount | formatVND }}</h1>
                </div>
            </div>
            <div class="col-xl-2 col-md-12 mt-2">
                <div class="table-config p-4 text-center custom-border custom-background justify-content-center overflow-auto">
                    <label style="font-size: 22px">Số khu vực</label>
                    <h1 class="mt-2" style="font-size: 30px">{{ totalArea }}</h1>

                </div>
            </div>
            <div class="col-xl-2 col-md-12 mt-2">
                <div class="table-config p-4 text-center custom-border custom-background justify-content-center overflow-auto">
                    <label style="font-size: 22px">Văn phòng</label>
                    <h1 class="mt-2" style="font-size: 30px">{{ totalBranches }}</h1>
                </div>
            </div>
            <div class="col-xl-2 col-md-12 mt-2">
                <div class="table-config p-4 text-center custom-border custom-background justify-content-center overflow-auto">
                    <label style="font-size: 22px">Số khách hàng</label>
                    <h1 class="mt-2" style="font-size: 30px">{{ totalCustomer }}</h1>
                </div>
            </div>
            <div class="col-xl-2 col-md-12 mt-2">
                <div class="table-config text-center p-4 custom-border custom-background justify-content-center overflow-auto">
                    <label style="font-size: 22px">Số hợp đồng</label>
                    <h1 class="mt-2" style="font-size: 30px">{{ totalContract }}</h1>
                </div>
            </div>
            <div class="col-xl-3 col-md-12 mt-2">
                <div class="table-config text-center p-4 custom-border custom-background justify-content-center overflow-auto">
                    <label style="font-size: 22px">Doanh số trung bình/ Văn phòng</label>
                    <h1 class="mt-2" style="font-size: 30px">{{ totalBranches ? totalAllAmount / totalBranches : 0 | formatVND }}</h1>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-6 d-lg-flex p-0 mb-3">
            <div class="col-xl-5 col-lg-6 col-md-12">
                <div class="table-config p-4 overflow-auto background-linear mb-3" style="height: 400px;">
                    <p style="font-weight: bold; font-size: 20px; color: black!important;">KẾT QUẢ KINH DOANH RSM</p>
                    <table class="table-report w-100 text-left table" style="font-size: 15px; width: 1000px !important;">
                        <thead class="custom-thead">
                            <tr>
                                <th>Top</th>
                                <th>Nhóm RSM</th>
                                <th>Vùng</th>
                                <th>Chỉ tiêu</th>
                                <th>Doanh thu</th>
                                <th class="text-left">%KPI</th>
                            </tr>
                        </thead>
                        <tbody class="custom-tbody">
                            <tr v-for="(item, index) in salesData" :key="index" class="p-2">
                                <td :class="index < 3 ? '' : 'text-center'">
                                    <img
                                        v-if="index < 3"
                                        :src="getRank(index)"
                                        alt="rank-icon"
                                        style="width: 45px; height: 45px; object-fit: cover;"
                                    >
                                    <span v-else style="margin-right: 18px">{{ index + 1 }}</span>
                                </td>
                                <td>{{ item.name }} </td>
                                <td>{{ item.regions_name }}</td>
                                <td>{{ item.totalTarget | formatVND}}</td>
                                <td>{{ item.totalAmount | formatVND}}</td>
                                <td>{{ item.percent }} %</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-xl-7 col-lg-6 col-md-12">
                <div class="p-4 table-config overflow-auto background-linear" style="height: 400px;">
                    <p style="font-weight: bold; font-size: 20px; color: black!important;">KẾT QUẢ KINH DOANH KHU VỰC
                        <el-select clearable v-model="areaId" class="ml-4" filterable placeholder="Chọn khu vực" @change="changeArea">
                            <el-option
                                v-for="(item, index) in allArea"
                                :key="index"
                                :label="item.name"
                                :value="item.id">
                                <span style="float: left">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </p>

                    <table class="table-report w-100 text-left table" style="font-size: 15px; width: 1500px !important;">
                        <thead class="custom-thead">
                            <tr>
                                <th>Top</th>
                                <th>Khu vực</th>
                                <th>Số VP</th>
                                <th>Chỉ tiêu</th>
                                <th>Doanh thu</th>
                                <th>%KPI</th>
                                <th>Số KH</th>
                                <th>DS trung bình/VP</th>
                                <th class="text-left">Chi lương KD</th>
                                <th class="text-left">Tổng khoản chi</th>
                                <th>Lợi nhuận KD</th>
                            </tr>
                        </thead>
                        <tbody class="custom-tbody">
                            <tr v-for="(item, index) in allArea" :key="index" class="p-2">
                                <td :class="index < 3 ? '' : 'text-center'">
                                    <img v-if="index < 3" :src="getRank(index)" alt="logo-zalo" style="width: 45px; height: 45px; object-fit: cover;">
                                    <span v-else style="margin-right: 18px">{{ index + 1 }}</span>
                                </td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.branches.length }}</td>
                                <td>{{ item.totalTarget | formatVND }}</td>
                                <td>{{ item.totalAmount | formatVND }}</td>
                                <td>{{ item.percent }} %</td>
                                <td>{{ item.totalCustomer }}</td>
                                <td>{{ item.totalTarget | formatVND }}</td>
                                <td>{{ item.total_chi_luong_kd |formatVND }}</td>
                                <td>{{ item.total_tong_khoan_chi |formatVND }}</td>
                                <td>{{ item.totalAmount - item.total_tong_khoan_chi |formatVND }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <div class="col-md-12 table-config p-4 background-linear overflow-auto" style="height: 700px;">
                <div class="d-flex mb-4">
                    <div class="col-md-2 p-0 mt-1">
                        <div style="font-weight: bold; font-size: 20px; color: black!important;" >DOANH SỐ THEO VĂN PHÒNG</div>
                    </div>
                    <div class="col-md-2">
                        <el-select clearable v-model="branchId" filterable class="w-100"
                                   placeholder="Chọn văn phòng" @change="changeBranch">
                            <el-option
                                v-for="(item, index) in branches"
                                :key="index"
                                :label="item.name"
                                :value="item.id">
                                <span style="float: left">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <table class="table-report w-100 text-left table table-report-over" style="width: 2000px !important;">
                    <thead class="custom-thead">
                        <tr>
                            <th>Top</th>
                            <th>Mã</th>
                            <th>Chi nhánh</th>
                            <th>Giám đốc văn phòng</th>
                            <th >Chỉ tiêu</th>
                            <th >Doanh thu</th>
                            <th >%KPI</th>
                            <th >Số SL</th>
                            <th >Chi lương KD</th>
                            <th >Tỷ lệ chốt</th>
                            <th >Số hợp đồng</th>
                            <th >Tổng các khoản chi</th>
                            <th >Lợi nhuận  KD</th>
                        </tr>
                    </thead>
                    <tbody class="custom-tbody">
                        <tr v-for="(item, index) in allBranches" :key="index">
                            <td>
                                <img v-if="index < 3" :src="getRank(index)" alt="logo-zalo" style="width: 45px; height: 45px; object-fit: cover;">

                                <span v-else>{{ index + 1 }}</span>
                            </td>
                            <td>{{ item.id }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.gdvp_name }}</td>
                            <td>{{ item.data.target |formatVND }}</td>
                            <td>{{ item.data.amount |formatVND }}</td>
                            <td>{{ getPercentRate(item.data.percent) }} %</td>
                            <td>{{ item.data.sale_leader }}</td>
                            <td>{{ item.data.business_cost |formatVND }}</td>
                            <td>{{ getClosingRate(item) }} %</td>
                            <td>{{ item.data.new_contracts }}</td>
                            <td>{{ item.data.total_cost |formatVND}}</td>
                            <td>{{ item.data.amount - item.data.total_cost |formatVND }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <div class="col-md-12 table-config p-4 custom-background custom-border">
                <p>Giải thích số liệu trên báo cáo:</p>
                <p>1. Chỉ tiêu doanh số: Chi tiêu doanh số theo tháng, gắn liền với văn phòng và Giám đốc văn phòng</p>
                <p>2. Số liệu doanh thu: Dựa trên số liệu Doanh thu ghi nhận theo Mã giới thiệu (Mã văn phòng)</p>
                <p>3. Số liệu doanh trên báo cáo sẽ khác với số liệu doanh thu tổng</p>
            </div>
        </div>
    </div>
</template>

<script>
import { query } from "vue-gtag";

import {REPORT_LIST_RSM, REPORT_RSM_BAO_CAO_DOANH_SO} from "../../../core/services/store/report.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {
    Chart as ChartJS,
    Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,
} from 'chart.js'
import Chart from 'chart.js/auto';
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    // báo cáo doanh số
    name: "SalesReport",
    data() {
        return {
            salesData: [],
            totalCurrentYear: 0,
            target: 0,
            percent: 0,
            totalAllAmount: 0,
            topGdvp: [],
            bottomGdvp: [],
            allArea: [],
            allAreaOrigin: [],
            areas: [],
            allBranches: [],
            allBranchesOrigin: [],
            month: 1,
            query: {
                user_ids: [],
                branchId: [],
                date_range: []
            },
            users: [],
            branches: [],
            chartInstances: new Map(),
            areaId: '',
            branchId: '',
            totalTarget: 0,
            totalBranches: 0,
            totalCustomer: 0,
            totalContract: 0,
            totalArea: 0,
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Báo cáo doanh số", icon: 'far fa-calendar-alt'}
        ]);
        this.getNow();
        this.getData();
        this.getUsers();
    },
    methods: {
        getNow()
        {
            const now = new Date();
            const year = now.getFullYear();
            const start = `${year}-01`;

            const end = `${year}-12`;
            this.query.date_range = [start, end];
        },
        getData()
        {
            this.$store.dispatch(REPORT_RSM_BAO_CAO_DOANH_SO, this.query).then((res) => {
                this.topGdvp = res.data.top_gdvp;
                this.bottomGdvp = res.data.bottom_gdvp;
                this.salesData = res.data;
                this.handleDataRSM();
            });
        },
        getTopGdvp(id)
        {
            this.topGdvp = this.topGdvp.filter(item => item.id == id);
            this.bottomGdvp = this.bottomGdvp.filter(item => item.id == id);

        },
        handleDataKpiMonth()
        {
            Object.values(this.kpiMonth).map((item) => {
                item.percent = item.target ?  Math.round((item.amount / item.target) * 100) : 0;
                return item;
            })
            this.totalCurrentYear = Object.values(this.kpiMonth).reduce((total, item) => total + Number(item.amount), 0);
            this.target = Object.values(this.kpiMonth).reduce((total, item) => total + Number(item.target), 0);
            this.percent = this.target ? Math.round((this.totalCurrentYear / this.target) * 100) : 0;
            this.settingPrecent();
        },
        sortMonth()
        {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';

            if (this.sortOrder == 'desc')
            {
                this.kpiMonth = Object.values(this.kpiMonth).sort((a, b) => new Date(b.month) - new Date(a.month));

                return;
            }
            this.kpiMonth = Object.values(this.kpiMonth).sort((a, b) => new Date(a.month) - new Date(b.month));
        },
        handleDataRSM()
        {
            let totalBranches = 0;
            let totalArea = 0;
            let totalAmount = 0;
            let totalCustomer = 0;
            let totalContract = 0;

            this.salesData = this.salesData.map((item) => {
                let totalTarget = 0;

                item.areas.forEach(area => {
                    let areaTarget = 0;
                    let areaAmount = 0;
                    let total_chi_luong_kd = 0;
                    let total_tong_khoan_chi = 0;

                    area.branches.forEach(branch => {

                        const target = parseFloat(branch.data.target || 0);
                        const amount = Number(branch.data.amount || 0);
                        const chi_luong_kd = Number(branch.data.business_cost || 0);
                        const tong_khoan_chi = Number(branch.data.total_cost || 0);
                        const customers = Number(branch.data.customers || 0);
                        const contract = Number(branch.data.new_contracts || 0);
                        areaTarget += target;
                        areaAmount += amount;
                        totalCustomer += customers;
                        totalContract += contract;
                        total_chi_luong_kd += chi_luong_kd;
                        total_tong_khoan_chi += tong_khoan_chi;
                        branch.data.percent = target > 0 ? (amount / target) * 100 : 0;
                        branch.data.area_name = area.name;
                        totalBranches++;

                        return branch;
                    });

                    area.totalCustomer = totalCustomer;
                    area.totalContract = totalContract;
                    area.totalTarget = areaTarget;
                    area.totalAmount = areaAmount;
                    area.total_chi_luong_kd = total_chi_luong_kd;
                    area.total_tong_khoan_chi = total_tong_khoan_chi;
                    area.percent = areaTarget > 0 ? ((areaAmount / areaTarget) * 100).toFixed(2) : 0;
                    totalArea++;
                    totalTarget += areaTarget;
                    totalAmount += areaAmount;
                });

                item.totalTarget = totalTarget;
                item.totalAmount = totalAmount;
                item.percent = totalTarget > 0 ? ((totalAmount / totalTarget) * 100).toFixed(2) : 0;

                return item;
            }).sort((a, b) => b.percent - a.percent);
            this.totalContract = totalContract;
            this.totalCustomer = totalCustomer;
            this.totalAllAmount = totalAmount;
            this.totalBranches = totalBranches;
            this.totalArea = totalArea;

            this.allBranches = this.salesData.flatMap(item =>
                item.areas.flatMap(area => area.branches || [])
            );
            this.allBranchesOrigin = this.allBranches;

            const uniqueObjects = Array.from(this.allBranches.reduce((map, obj) => {
                if (!map.has(obj.id)) {
                    map.set(obj.id, obj);
                }
                return map;
            }, new Map()).values());
            this.branches = uniqueObjects;

            this.allArea = this.salesData.flatMap(item =>
                item.areas || []
            ).sort((a, b) => b.percent - a.percent);
            this.allAreaOrigin = this.allArea;
            // this.areas = this.allArea;

        },
        search(value)
        {
            this.month = value;
            this.getData();
        },
        getUsers()
        {
            this.$store.dispatch(REPORT_LIST_RSM, {}).then((res) => {
                this.users = res.data;
            });
        },
        changeDataRSM(id)
        {

        },
        changeArea()
        {
            if (!this.areaId) {
                this.allArea = this.allAreaOrigin;
                return;
            }
            let data = Object.values(this.allAreaOrigin).filter(item => {
                return item.id === this.areaId;
            });
            console.log(this.allAreaOrigin, this.areaId, 'this.areaId')
            this.allArea = data;
        },
        changeBranch()
        {
            if (!this.branchId) {
                this.allBranches = this.allBranchesOrigin;
                return;
            }
            let data = Object.values(this.allBranchesOrigin).filter(item => {
                return item.id === this.branchId;
            }).sort((a, b) => b.data.amount - a.data.amount);
            this.allBranches = data;
        },
        settingPrecent()
        {
            const refKey = `chart-table`;
            const canvas = this.$refs[refKey];
            const ctx = Array.isArray(canvas) ? canvas[0] : canvas;
            if (!ctx)
            {
                return;
            }
            const maxPercent = 100;
            if (this.chartInstances.has(canvas)) {
                this.chartInstances.get(canvas).destroy();
                this.chartInstances.delete(canvas);
            }
            const config = {
                type: 'bar',
                data: {
                    labels: [''],
                    datasets: [{
                        label: this.percent.toFixed(1) + '%',
                        data: [this.percent],
                        backgroundColor: '#b2f2bb',
                    }]
                },
                options: {
                    indexAxis: 'y',
                    responsive: false,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            display: true,
                            min: 0,
                            max: maxPercent,
                            ticks: {
                                stepSize: 100,
                                color: '#fff',
                                font: {
                                    size: 5,
                                    weight: 'bold'
                                }
                            },
                            grid: {
                                display: true,
                                color: 'rgba(255,255,255,0.2)',
                            }
                        },
                        y: {
                            display: false
                        }
                    },
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false }
                    }
                }
            };
            this.createOrUpdateChart(refKey, config);

        },
        createOrUpdateChart(refKey, chartConfig) {
            const canvas = this.$refs[refKey];
            const ctx = Array.isArray(canvas) ? canvas[0] : canvas;
            if (!ctx) return;

            if (this.chartInstances.has(refKey)) {
                this.chartInstances.get(refKey).destroy();
                this.chartInstances.delete(refKey);
            }

            const chart = new Chart(ctx, chartConfig);
            this.chartInstances.set(refKey, chart);
        },
        changeDate()
        {

            this.getData();
        },
        getClosingRate(item)
        {
            return item.data.customers ? ((item.data.new_contracts / item.data.customers) * 100).toFixed(2) : 0
        },
        getPercentRate(item)
        {
            return item.toFixed(2);
        },
        getRank(index)
        {
            switch (index) {
                case 0:
                    return '/media/top1.png'
                case 1:
                    return '/media/top2.png'
                case 2:
                    return '/media/top3.png'
            }
        }
    }
}
</script>

<style scoped>
    .bg-violet {
        background-color: rgb(47, 28, 74);
    }
    .text-violet {
        color: #5f259f;
    }
    .table thead th {
        border-bottom: unset;
    }
    .table-config {
        background: linear-gradient(135deg, rgb(130, 48, 206) 0%, rgb(80, 54, 148) 100%);
        box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 2px 0px, rgba(0, 0, 0, 0.15) 0px 1px 3px 1px;
    }
    .custom-border {
        border-radius: 20px!important;
    }
    .custom-background {
        background: rgb(91 63 131)!important;
    }
    .custom-padding-table {
        padding-top: 15px!important;
    }
    .background-linear {
        background: rgba(255, 255, 255, 0.9)!important;
        box-shadow:
            0 4px 6px rgba(139, 92, 246, 0.07),
            0 10px 15px rgba(139, 92, 246, 0.1),
            0 0 0 1px rgba(255, 255, 255, 0.05);
        border-radius: 10px!important;
    }
    .custom-thead {
        background: rgba(139, 92, 246, 0.05);
    }
    .custom-tbody {
        background: white;
        color: black!important;
    }
    .table-config {
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
    .table-report-over {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    /* THEAD - Flexbox */
    .table-report-over thead {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        padding-right: 6px;
    }

    .table-report-over thead tr {
        display: flex;
        width: 100%;
    }

    .table-report-over thead th {
        flex: 1; /* Chia đều các cột */
        padding: 12px;
        text-align: center;
    }

    .table-report-over tbody {
        flex: 1;
        overflow-y: auto;
        display: block;
    }

    .table-report-over tbody tr {
        display: flex;
        width: 100%;
    }

    .table-report-over tbody td {
        flex: 1;
        padding: 12px;
        text-align: center;
    }

    .table tbody tr:hover {
        background: rgba(102, 51, 153, 0.3);
    }

    /* Scrollbar đẹp */
    .table-report-over tbody::-webkit-scrollbar {
        width: 6px;
    }

    .table-report-over tbody::-webkit-scrollbar-thumb {
        background: #8A2BE2;
        border-radius: 3px;
    }
    @media (min-width: 1520px) {
        .col-xl-2 {
            max-width: 12.6667%;
        }
    }
</style>
